import(/* webpackMode: "eager", webpackExports: ["GoogleOAuthButton"] */ "/vercel/path0/apps/main-app/src/app/auth/components/GoogleOAuthButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SignInForm"] */ "/vercel/path0/apps/main-app/src/app/auth/components/SignInForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["makeApolloClient"] */ "/vercel/path0/apps/main-app/src/lib/apolloWrapper.ts");
;
import(/* webpackMode: "eager", webpackExports: ["SimulatePreloadedQuery"] */ "/vercel/path0/node_modules/@apollo/client-react-streaming/dist/index.cc.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
